import React, { useState, useEffect } from 'react';
import './TempleOfDay.css';

const FAITH_LABELS = {
  hindu:    { en: 'Hindu',    hi: 'हिंदू',   color: 'var(--hindu)' },
  buddhist: { en: 'Buddhist', hi: 'बौद्ध',   color: 'var(--buddhist)' },
  jain:     { en: 'Jain',     hi: 'जैन',     color: 'var(--jain)' },
};

function getTodaysTemple(temples) {
  const epoch = new Date(2024, 0, 1);
  const today = new Date();
  const day = Math.floor((today - epoch) / 86400000);
  return temples[day % temples.length];
}

function formatDate(lang) {
  const d = new Date();
  return d.toLocaleDateString(lang === 'hi' ? 'hi-IN' : 'en-IN', {
    day: 'numeric', month: 'long', year: 'numeric'
  });
}

export default function TempleOfDay({ lang }) {
  const [temple, setTemple] = useState(null);
  const [storyOpen, setStoryOpen] = useState(false);
  const [imgError, setImgError]   = useState(false);
  const L = (en, hi) => lang === 'en' ? en : hi;

  useEffect(() => {
    fetch(`${process.env.PUBLIC_URL}/data/featured_temples.json`)
      .then(r => r.json())
      .then(list => setTemple(getTodaysTemple(list)))
      .catch(console.error);
  }, []);

  if (!temple) return null;

  const hasImg = temple.image_url && !imgError;
  const faith = FAITH_LABELS[temple.faith] || FAITH_LABELS.hindu;
  const name  = L(temple.name_en,  temple.name_hi);
  const sub   = L(temple.name_hi,  temple.name_en);
  const deity = L(temple.deity_en, temple.deity_hi);
  const sig   = L(temple.significance_en, temple.significance_hi);
  const story = L(temple.story_en, temple.story_hi);
  const state = L(temple.state_en, temple.state_hi);
  const loc   = temple.city ? `${temple.city}, ${state}` : state;

  return (
    <section className="tod-wrap">
      <div className="tod-label">
        <span className="tod-label-dot" />
        {L('Temple of the Day', 'आज का मंदिर')}
        <span className="tod-date">{formatDate(lang)}</span>
      </div>

      <div className="tod-card">
        {hasImg && (
          <div className="tod-hero-wrap">
            <img className="tod-hero-img" src={temple.image_url} alt={name} onError={() => setImgError(true)} />
            <div className="tod-hero-gradient" />
          </div>
        )}
        <div className="tod-card-top">
          <div className="tod-faith-row">
            <span className="tod-faith-dot" style={{ background: faith.color }} />
            <span className="tod-faith-label">{L(faith.en, faith.hi)}</span>
            {temple.alzhwar_star   && <span className="tod-badge-alzhwar"><span style={{color:'#c0392b'}}>☸</span> {L('Divya Desam','दिव्य देसम')}</span>}
            {temple.nayanmars_star && <span className="tod-badge-nayanmars">🔱 {L('Paadal Petra','पादल पेट्र')}</span>}
          </div>
          <h2 className="tod-name">{name}</h2>
          {sub !== name && <p className="tod-name-sub">{sub}</p>}
          <div className="tod-location-row">
            <span className="tod-location">📍 {loc}</span>
            <span className="tod-state-chip">{state}</span>
          </div>
        </div>

        <div className="tod-divider" />

        <div className="tod-body">
          <div className="tod-main">
            {deity && <p className="tod-deity-row">{L('Deity:','देवता:')} <strong>{deity}</strong></p>}
            {temple.dynasty && (
              <p className="tod-dynasty-row">
                {temple.dynasty}{temple.century ? ` · ${temple.century}` : ''}
              </p>
            )}
            {sig && (
              <>
                <p className="tod-sig-label">{L('Significance','महत्त्व')}</p>
                <p className="tod-sig-text">{sig}</p>
              </>
            )}
            {story && (
              <div className="tod-story-section">
                <button className="tod-story-toggle" onClick={() => setStoryOpen(o => !o)}>
                  {storyOpen ? L('Hide story ↑','कहानी छुपाएं ↑') : L('Read the story →','पूरी कहानी पढ़ें →')}
                </button>
                {storyOpen && <p className="tod-story-text fade-in">{story}</p>}
              </div>
            )}
          </div>

          {(temple.dynasty || temple.century) && (
            <div className="tod-meta-panel">
              {temple.dynasty && (
                <div className="tod-meta-item">
                  <span className="tod-meta-key">{L('Dynasty','राजवंश')}</span>
                  <span className="tod-meta-val">{temple.dynasty}</span>
                </div>
              )}
              {temple.century && (
                <div className="tod-meta-item">
                  <span className="tod-meta-key">{L('Period','काल')}</span>
                  <span className="tod-meta-val">{temple.century}</span>
                </div>
              )}
              {temple.district && (
                <div className="tod-meta-item">
                  <span className="tod-meta-key">{L('District','जिला')}</span>
                  <span className="tod-meta-val">{temple.district}</span>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
